import './filters-style.scss'

import { useUserRegionCH } from '@cdc-internal/mkt-nav-footer'
import classNames from 'classnames'
import _ from 'lodash'
import React, { useCallback, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { getTransWithoutMissingKey } from '@/i18n/config'
import { useUKAccess } from '@/modules/useUKAccess'

import { useCategories } from '../../hooks/useCategories'
import Button from '../button-filter/button-filter'
import { orderFilterItems } from './filter-order'
import { useHashUrlFilter } from './use-hash-url-filter'

const researchCatOrder = {
  'Most Read': 0,
  Feature: 1,
  'Market Sizing': 2,
  Roundup: 3,
  DeFi: 4,
  Surveys: 5,
  Others: 6,
}

const Filters = ({
  title,
  titleTwo,
  onClick,
  type = 'event',
  typeTwo = undefined,
  selectedCategories = {},
  noTrending,
}) => {
  const [subCategories, setSubCategories] = useState([])
  const [subCategoriesTwo, setSubCategoriesTwo] = useState([])
  const { withSubCategories } = useCategories()
  const { t, i18n } = useTranslation()
  const isUKIp = useUKAccess()
  const userRegion = useUserRegionCH()

  const onFilter1Click = useCallback(
    (name) => {
      const newState = { ...selectedCategories }
      newState[type] = name === selectedCategories[type] ? null : name
      onClick(newState)
    },
    [onClick, selectedCategories, type]
  )

  const onFilter2Click = useCallback(
    (name) => {
      const newState = { ...selectedCategories }
      newState[typeTwo] = name === selectedCategories[typeTwo] ? null : name
      onClick(newState)
    },
    [onClick, selectedCategories, typeTwo]
  )
  useEffect(() => {
    const category = _.filter(withSubCategories, (c) => c.description === type)
    let categoryArray = _.get(_.head(category), 'wpChildren', [])
    if (type === 'research') {
      categoryArray = _.sortBy(categoryArray, (c) => researchCatOrder[c.name])
    }
    if (type === 'university' && isUKIp) {
      categoryArray = _.filter(
        categoryArray,
        (c) => c.slug !== 'derivatives-university-en'
      )
    }
    if (type === 'product-news' && userRegion === 'FR') {
      categoryArray = _.filter(
        categoryArray,
        (c) => c.slug !== 'exchange-product-news-en'
      )
    }

    if (type === 'product-news' && userRegion === 'AE') {
      categoryArray = _.filter(
        categoryArray,
        (c) => c.slug !== 'pay-product-news-en'
      )
    }

    setSubCategories(categoryArray)

    if (typeTwo) {
      const category2 = _.filter(
        withSubCategories,
        (c) => c.description === typeTwo
      )
      setSubCategoriesTwo(
        orderFilterItems(
          typeTwo,
          _.get(_.head(category2), 'wpChildren', []),
          isUKIp,
          userRegion
        )
      )
    }
  }, [type, typeTwo, withSubCategories, isUKIp, userRegion])

  useHashUrlFilter(
    selectedCategories,
    subCategories,
    subCategoriesTwo,
    type,
    typeTwo,
    onClick
  )

  return (
    <div
      className={classNames({
        'container-filters': true,
        'no-trending': noTrending,
      })}
    >
      <div className="container-type-filters">
        <p className="text-type-filters">{t(`ui.filters.${title}`)}: </p>
        <div className="box-type-filters">
          {_.map(subCategories, (button) => (
            <Button
              key={button.slug}
              name={getTransWithoutMissingKey(
                `categories.${button.slug}`,
                i18n,
                t
              )}
              slug={button.slug}
              onPress={() => onFilter1Click(button.description)}
              active={selectedCategories[type] === button.description}
              hash={button.description}
            />
          ))}
        </div>
      </div>
      {typeTwo && (
        <div className="container-type-filters">
          <>
            <p className="text-type-filters">{t(`ui.filters.${titleTwo}`)}: </p>
            <div className="box-type-filters">
              {_.map(subCategoriesTwo, (button) => (
                <Button
                  type={typeTwo}
                  key={button.slug}
                  name={getTransWithoutMissingKey(
                    `categories.${button.slug}`,
                    i18n,
                    t
                  )}
                  slug={button.slug}
                  hash={button.description}
                  onPress={() => onFilter2Click(button.description)}
                  active={selectedCategories[typeTwo] === button.description}
                />
              ))}
            </div>
          </>
        </div>
      )}
    </div>
  )
}

export default Filters
